/* istanbul ignore file */

// Navigator clipboard api needs a secure context (https)
async function hasPermissions () {
    return new Promise((resolve, reject) => {
        if (window.isSecureContext) {
            resolve()
        } else {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject()
        }
    })
}

export function copyToClipboard (textToCopy) {
    return new Promise((resolve, reject) => {
        hasPermissions().then(() => {
            navigator.clipboard.writeText(textToCopy)
            resolve()
        }).catch((error) => {
            reject(error)
        })
    })
}